import React from 'react'
import Layout from '../../Layout/Layout'
import nextTech from "../../images/nextTech.PNG"

const Nextechczar_Incubation_Program = () => {
  return (
    <Layout>
             <div className='uk-container'>
                 <h2 className='uk-text-bold uk-margin-xlarge-top light'>Nextechczar Incubation Program</h2>

                <div className='uk-grid'>
                    <div className='uk-width-1-2@s'>
                        <p className='light'>The NextechCzar Incubation Program is a flagship 
                            initiative of Moolu Venture Lab, delivered in partnership with
                             LAPO Microfinance Bank Plc, to identify, nurture, and accelerate
                              20 high-potential startups through a structured incubation model
                               that equips founders with technical expertise, market intelligence,
                                entrepreneurial education, and investment readiness tools needed to
                                 transform early-stage concepts into scalable ventures.</p>

                                 <p className='light'>Built on the Mission of strengthening Nigeria’s innovation landscape, 
                                    the program empowers young women and youth entrepreneurs with the
                                     knowledge, mentorship, networks, and resources required to develop
                                      sustainable, impactful solutions that address real socioeconomic 
                                      challenges while contributing to national development priorities
                                       and global sustainability goals. </p>
                    </div>

                     <div className='uk-width-1-2@s'>
                           <div className=''>
                            <img src={nextTech}/>
                           </div>
                    </div>

                </div>


                <div className='uk-grid uk-margin-large-top'>
                    <div className='uk-width-1-2@s'>
                         <p className='light'> Through an immersive dual -track curriculum for early stage 
                            and high growth venture, hands-on coaching, and deep industry 
                            engagement, NextechCzar enhances founders’ capabilities in product
                             design, business modelling, financial management, regulatory navigation, 
                             and market expansion, resulting in stronger, investment-ready enterprises.
                              The program delivers measurable outcomes including improved venture
                               survival rates, increased access to funding, expanded market penetration,
                                and meaningful contributions to job creation and community upliftment.</p>

                                <p className='light'>Its broader impact is reflected in the emergence of high-performance
                                     startups able to attract local and international investors, integrate
                                      advanced technologies, and scale solutions that address critical gaps 
                                      across key sectors. </p>
                    </div>

                    <div className='uk-width-1-2@s'>
                           <p className='light'>Strategically aligned with Moolu Venture Lab’s long-term vision,
                             NextechCzar strengthens the organisation’s commitment to inclusive, sustainable 
                             innovation by building a robust pipeline of founders equipped to drive economic
                              transformation.</p>

                                <p className='light'> By integrating research support, ethical innovation principles,
                                     policy alignment, and blended financing mechanisms through its partnership with 
                                     LAPO Microfinance Bank Plc, the program reinforces Moolu Venture Lab’s overarching
                                      goal of building a globally competitive innovation ecosystem that empowers 
                                      entrepreneurs to solve Africa’s most pressing development challenges.
</p>
                    </div>
                </div>




             </div>
        </Layout>
  )
}

export default Nextechczar_Incubation_Program